import type { Issue } from './issue'

type Scope = {
	readonly tags?: readonly string[]
}

const inScope = (issue: Issue, { tags }: Scope): boolean => {
	if (!tags || tags.length === 0) return true

	const have = new Set(issue.tags.map(tag => tag.toLowerCase()))

	return tags.every(tag => have.has(tag.toLowerCase()))
}

export { inScope }
